/**
 * 화면ID : COMCMP004-04FP
 */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ErrorInfo } from 'scbk-services';
import { PageType, PropsWithPopup } from 'scbk-services';
import { withPageComponent } from 'scbk-shared-module';
import { DialogWrapper, ErrorCard } from 'scbk-ui-web';

interface Props extends PropsWithPopup {
  onComplete?: () => void;
  errorInfo: ErrorInfo | undefined;
}

/**
 * 에러 팝업 컴포넌트
 */
export const ErrorPopupComponent = withPageComponent<Props>(
  'ErrorPopupComponent',
  { type: PageType.FULL_POPUP },
  function ({ isOpen, setOpen, onComplete, errorInfo }) {
    const { t } = useTranslation();

    /**
     * Content 내용이 String 배열일 경우 렌더링 처리
     * @param content
     * @returns
     */
    const renderContent = (content?: string | string[] | React.ReactNode): React.ReactNode => {
      if (!content) return null;

      if (typeof content === 'string') {
        return content
          .split(/<br\s*\/?>/i)
          .filter((line) => line.trim() !== '')
          .map((line, index, arr) => (
            <React.Fragment key={index}>
              {line}
              {index < arr.length - 1 && <br />}
            </React.Fragment>
          ));
      }
    };

    /**
     * 오류 메시지 획득
     */
    const errorMessage = useMemo(() => {
      return renderContent(errorInfo?.errorMessage ?? '');
    }, [errorInfo?.errorMessage]);

    return (
      <DialogWrapper
        title={'Error'}
        open={isOpen}
        setOpen={setOpen}
        isFull
        footer={[
          {
            type: 'primary',
            title: t('ErrorPopupComponent.001', {
              defaultValue: '확인',
            }),
            hasClose: true,
            handler: () => {
              onComplete?.();
            },
          },
        ]}
      >
        <div className="flex flex-col items-center justify-center h-[calc(100vh-360px)] pt-[100px] md:pt-[10px] md:h-[320px]">
          <ErrorCard label={`${errorInfo?.code ?? ''}`}>
            <span className="text-state-disabled-04">{errorMessage ?? ''}</span>
            <br />
            {errorInfo?.errorGuideMessage?.map((item) => (
              <>
                <span className="text-state-disabled-04">{item}</span>
                <br />
              </>
            ))}
          </ErrorCard>
        </div>
      </DialogWrapper>
    );
  },
);
